import { Center, Text } from '@chakra-ui/react';
import { formatDateTimeHomePage } from '../../../../../../../util/dates';

type SaleDateDisplayProps = {
  saleDate: string;
};

export const SaleDateDisplay = (props: SaleDateDisplayProps) => {
  const { saleDate } = props;
  return (
    <Center height={'46px'}>
      <Text fontSize={'md'} fontWeight={'semibold'} whiteSpace='nowrap'>
        {formatDateTimeHomePage(saleDate)}
      </Text>
    </Center>
  );
};
